var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor-thumb",on:{"click":_vm.getArtista}},[_c('div',{staticClass:"wrapper-imagen"},[_c('img',{attrs:{"src":_vm.foto,"alt":""}})]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.scanTexto(_vm.artista.nombre_artista))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }